module.exports = __webpack_public_path__ + "static/img/14011C_2_3_5_6_R_20181114_fit.0199dc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14011C_2_3_5_6_R_20181114_fit.png
// module id = y4mS
// module chunks = 0